<template>
  <e-modal-custom-form
    ref="modalDeleteForm"
    title="Exclusão do pedido de compra"
    @after-confirm="$emit('after-confirm')"
  >
    <b-row>
      <b-col
        md="12"
        class="d-flex flex-column"
      >
        <FormulateInput
          id="delete_modal-reason"
          v-model="deleteForm.reason"
          name="reason"
          class="w-100 required"
          type="textarea"
          validation="required|min:15,length"
          rows="4"
          :label="$t('Motivo da exclusão')"
        />
      </b-col>
    </b-row>
  </e-modal-custom-form>
</template>

<script>
import EModalCustomForm from '@/views/components/EModalCustomForm.vue'
import { BCol, BRow } from 'bootstrap-vue'
import { mapActions } from 'vuex'

const getDefaultDeleteForm = () => ({
  reason: ''
})

export default {
  name: "ModalDeletePurchaseOrder",

  components: {
    BCol,
    BRow,
    EModalCustomForm,
  },

  props: {},
  data() {
    return {
      deleteForm: getDefaultDeleteForm()
    }
  },
  methods: {
    ...mapActions('pages/purchase/purchaseOrder/purchaseOrderMaintain', {
      stDeletePurchaseOrder: 'deletePurchaseOrder',
    }),

    resetModal() {
      this.deleteForm = getDefaultDeleteForm()
    },

    async showModal(purchaseOrder) {
      this.resetModal()

      if (!this.$can('Delete', 'PurchaseOrder')) {
        this.showWarning({ message: this.$t('without_permission') })
        return
      }

      if (
        await this.confirmHtml({
          title: '',
          html: `Confirma excluir pedido de compra #${purchaseOrder.id}? Esta ação não poderá ser revertida depois.`,
        })
      ) {
        this.$refs.modalDeleteForm.show(async () => {
          try {
            await this.stDeletePurchaseOrder({
              purchaseOrderId: purchaseOrder.id,
              reason: this.deleteForm.reason
            })

            this.showSuccess({ message: this.$t('Pedido de compra excluído com sucesso.') })
          } catch (error) {
            this.showError(error)
          }
        })
      }
    },
  },
}
</script>
